module.exports = __webpack_public_path__ + "img/added_collection.95121ad9.svg";